import React, { useRef, useState } from "react";
import { Menu as MenuWrapper } from "primereact/menu";
import CustomeButton from "../Button";
import "./menu.scss";
const Menu = ({ menuItems }) => {
  const [showMenu, setShowMenu] = useState(false);
  const actionMenu = useRef(null);

  const actionButtonHandler = (event) => {
    actionMenu.current.toggle(event);
  };
  return (
    <div className="menu-wrapper">
      {
        <MenuWrapper
          id="popup_menu"
          className="menu-wrapper"
          model={menuItems}
          ref={actionMenu}
          popupAlignment="right"
          popup
          onHide={() => setShowMenu(false)}
        />
      }
      <CustomeButton
        icon="pi pi-ellipsis-v"
        aria-controls="popup_menu"
        variant="no-outlined"
        aria-haspopup
        onClick={(event) => actionButtonHandler(event)}
      />
    </div>
  );
};

export default Menu;
